import React, { useMemo, useEffect, useState, useRef } from "react";
import { Icon } from "@iconify/react";
// import Headline6 from "../../../../components/headings/Headline6";
import FromHead from "../../components/headings/FromHead";
// import Headline4 from "../../components/headings/Headline4";
import { FormInput } from "../../wrappers/formInput";
// import FormTextArea from '../../components/Field/textArea';
import Styles from "./styles.module.scss";
import Button from "../../components/button";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { DropDownInput } from "../../wrappers/selectInput";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
  EditorState,
  convertToRaw,
  convertFromRaw,
  ContentState,
} from "draft-js";
import { PhoneInput } from "../../wrappers/phoneInput";
import { convertToHTML } from "draft-convert";
import htmlToDraft from "html-to-draftjs";
import { getAPI, postAPI } from "../../api/api";

export type PersonalDetailsFormFields = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  country: string;
  nationality: string;
  linkedIn: string;
  control: any;
  github: string;
  stackoverflow: string;
  summary: string | undefined;
  city: string
};

interface Props {
  ClickHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
  // Back: (event: React.MouseEvent<HTMLButtonElement>) => void
  defaultValues: {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    nationality?: string | undefined;
    country?: string | undefined;
    github?: string | undefined;
    linkedIn?: string | undefined;
    stackoverflow: string | undefined;
    summary: string | undefined;
    city: string;
  };
  candidateStatus?: any;
  credentialSent?: boolean;
  disable?: boolean;
  countryList?: []
}

const validationSchema = Yup.object({
  firstName: Yup.string().required("Field is required"),
  lastName: Yup.string().required("Field is required"),
  email: Yup.string()
    .required("Field is required")
    .email("Please provide a valid email address").nullable(true),
  phoneNumber: Yup.string()
    .required("Field is required")
    .min(5, "Invalid Phone Number")
    .max(15, "Invalid Phone Number"),
  country: Yup.string().required("Field is required").nullable(true),
  city: Yup.string()
    .required("Field is required")
    .nullable(true),
  linkedIn: Yup.string()
    .transform((currentValue, originalValue) => {
      return originalValue === "" ? null : currentValue;
    })
    .nullable(true)
    .matches(
      /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/,
      "Please provide a valid link"
    ),
  stackoverflow: Yup.string()
    .transform((currentValue, originalValue) => {
      return originalValue === "" ? null : currentValue;
    })
    .nullable(true)
    .matches(
      /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/,
      "Please provide a valid link"
    ),
  github: Yup.string()
    .transform((currentValue, originalValue) => {
      return originalValue === "" ? null : currentValue;
    })
    .nullable(true)
    .matches(
      /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/,
      "Please provide a valid link"
    ),
});

const PersonalDetails: React.FC<Props> = ({ ClickHandler, defaultValues, candidateStatus, credentialSent , disable }) => {

  const formOptions = {
    resolver: yupResolver(validationSchema),
    defaultValues: useMemo(() => {
      return defaultValues;
    }, [defaultValues]),
  };

  const { register, handleSubmit, control, reset, setValue, formState, watch } =
    useForm<PersonalDetailsFormFields>(formOptions);

  const [editorState, setEditorState] = useState<any>(
    EditorState.createEmpty()
  )

  const inputRef = useRef<HTMLInputElement>(null);

  const [countryList, setCountryList] = useState<any>()
  const [cityList, setCityList] = useState<any>()

  
  useEffect(() => {
    setValue('city', '')
    if (watch().country) {
      getCities(watch().country)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch().country])

  useEffect(() => {
    if (formState.errors.country) {
      if (inputRef.current) {
        inputRef.current.scrollIntoView();
      }
    }
    if (formState.errors.phoneNumber && !formState.errors.country) {
      if (inputRef.current) {
        inputRef.current.scrollIntoView();
      }
    }
  }, [formState]);

  useEffect(() => {
    if (defaultValues) {
      if (defaultValues.summary) {
        if (defaultValues.summary.includes('{"blocks')) {
          let oldblockconverteddata = convertFromRaw(
            JSON.parse(defaultValues.summary)
          );
          let oldblockdataconvertedhtml = convertToHTML(oldblockconverteddata);

          defaultValues.summary = JSON.stringify(oldblockdataconvertedhtml);
        }
        if (
          defaultValues.summary.includes("<p>") ||
          defaultValues.summary.includes("<ol") ||
          defaultValues.summary.includes("<ul>")
        ) {
          setValue("summary", JSON.parse(defaultValues.summary));
        } else {
          setValue("summary", defaultValues.summary);
        }
        // setEditorState(EditorState.createWithContent(convertFromRaw(JSON.parse(defaultValues.summary))));
        const contentState = editorState.getCurrentContent();
        if (
          JSON.stringify(convertToRaw(contentState)) !== defaultValues.summary
        ) {
          try {
            setEditorState(
              EditorState.createWithContent(
                convertFromRaw(JSON.parse(defaultValues.summary))
              )
            );
          } catch (e) {
            let summarydata = defaultValues && defaultValues.summary;
            let convertdata = summarydata.includes("<p>");
            let olconvertdata = summarydata.includes("<ol");
            let ulconvertdata = summarydata.includes("<ul>");
            if (convertdata || olconvertdata || ulconvertdata) {
              const blocksFromHTML = htmlToDraft(JSON.parse(summarydata));
              const updateblockstate = ContentState.createFromBlockArray(
                blocksFromHTML.contentBlocks,
                blocksFromHTML.entityMap
              );
              setEditorState(EditorState.createWithContent(updateblockstate));
            } else {
              const blocksFromHTML = htmlToDraft(summarydata);
              const updateblockstate = ContentState.createFromBlockArray(
                blocksFromHTML.contentBlocks,
                blocksFromHTML.entityMap
              );
              setEditorState(EditorState.createWithContent(updateblockstate));
            }
          }
        }
      }
    }
    reset(defaultValues);
  }, [defaultValues]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getCountries();
  }, []);

  const getCountries = () => {
    let country: any = []
    getAPI('https://countriesnow.space/api/v0.1/countries').then((resp: any) => {
      if (resp.error === false){
        // eslint-disable-next-line array-callback-return
        resp.data && resp.data.map((item: any) => {
          country = [...country, item.country]
        })
      }   
      setCountryList(country)
    })
  }

  const getCities = (country: string) => {
    let body = { country }
    
    postAPI('https://countriesnow.space/api/v0.1/countries/cities', body).then((response: any) => {
       setCityList(response.data)
     })
  }

  const onSubmitForm = (data: any) => {
   // localStorage.setItem("Email", data.email);

    // if (data.github || data.linkedIn || data.stackoverflow) {
      if (!data.github) {
        delete data.github;
      }
      if (!data.linkedIn) {
        delete data.linkedIn;
      }
      if (!data.stackoverflow) {
        delete data.stackoverflow;
      }
      data.type = 'Personal Details'
      data.email =data.email.toLowerCase()
      ClickHandler(data);
    // } else {
    //   setSocialError(true);
    //   {
    //     if (inputRef.current) {
    //       inputRef.current.scrollIntoView();
    //     }
    //   }
    // }
  };

  const onEditorStateChange = (state: any) => {
    setEditorState(state);
    const contentState = state.getCurrentContent();
    let currentContentAsHTML = convertToHTML(contentState);
    setValue("summary", JSON.stringify(currentContentAsHTML));
  };

  return (
    <form>
      <section className={Styles.personalDetails}>
        {/* <Headline4>Personal Details</Headline4> */}
        <FromHead>Provide the candidate’s personal details</FromHead>
        <div className="half-form-wrap">
          <div className="form-group">
            <FormInput<PersonalDetailsFormFields>
              id="firstName"
              type="text"
              name="firstName"
              label="First Name*"
              placeholder="First Name"
              register={register}
              errors={formState.errors}
              // onBlur={handleSubmit(onSubmitForm)}
            />
          </div>
          <div className="form-group">
            <FormInput<PersonalDetailsFormFields>
              id="lastName"
              type="text"
              name="lastName"
              label="Last Name*"
              placeholder="Last Name"
              register={register}
              errors={formState.errors}
              // onBlur={handleSubmit(onSubmitForm)}
            />
          </div>
        </div>
        {formState.errors.country && <p id="first" ref={inputRef}></p>}
        <FromHead>Where does the candidate live?</FromHead>
        <div className="half-form-wrap">
          <div className="form-group">
            <DropDownInput<PersonalDetailsFormFields>
              data={countryList}
              name="country"
              label="Country*"
              control={control}
              register={register}
              errors={formState.errors}
            />
          </div>
          <div className="form-group">
            <DropDownInput<PersonalDetailsFormFields>
              data={countryList}
              name="nationality"
              label="Nationality"
              control={control}
              register={register}
              errors={formState.errors}
            />
          </div>
        </div>
        <div className="half-form-wrap">
        <div  className="form-group">
            <DropDownInput<PersonalDetailsFormFields>
              data={cityList}
              name="city"
              label="City*"
              control={control}
              register={register}
              errors={formState.errors}
            />
          </div>
          </div>

        <FromHead>Provide the candidate's contact details</FromHead>
        {formState.errors.phoneNumber && !formState.errors.country && (
          <p id="phone" ref={inputRef}></p>
        )}
        <div className="half-form-wrap">
          <div className="form-group">
            <FormInput<PersonalDetailsFormFields>
              id="email"
              type="text"
              name="email"
              label="Email*"
              placeholder="Email"
              register={register}
              errors={formState.errors}
              // onBlur={handleSubmit(onSubmitForm)}
              disabled={candidateStatus > 3 || credentialSent }
            />
          </div>
          <div className="form-group">
            <PhoneInput<PersonalDetailsFormFields>
              id="phoneNumber"
              type="text"
              name="phoneNumber"
              label="Phone Number*"
              size="medium"
              register={register}
              errors={formState.errors}
              control={control}
            />
          </div>
        </div>
        <FromHead>
          Which of the social profiles does the candidate use?
          <sub>Provide atleast one</sub>{" "}
          {/* {socialError && <p id="secojnd" ref={inputRef}></p>}
          {socialError && (
            <Error>Please provide atleast one social profile</Error>
          )} */}
        </FromHead>
        <div className="form-group">
          <label className="lablel">
            <Icon icon="jam:linkedin-square" />
            LinkedIn
          </label>
          <FormInput<PersonalDetailsFormFields>
            id="linkedIn"
            type="text"
            name="linkedIn"
            register={register}
            errors={formState.errors}
            placeholder="LinkedIn"
            // onBlur={handleSubmit(onSubmitForm)}
          />
        </div>
        <div className="form-group">
          <label className="lablel">
            <Icon icon="codicon:github" />
            GitHub
          </label>
          <FormInput<PersonalDetailsFormFields>
            id="github"
            type="text"
            name="github"
            placeholder="Github"
            register={register}
            errors={formState.errors}
            // onBlur={handleSubmit(onSubmitForm)}
          />
        </div>
        <div className="form-group">
          <label className="lablel">
            <Icon icon="academicons:stackoverflow" />
            StackOverflow
          </label>
          <FormInput<PersonalDetailsFormFields>
            id="stackoverflow"
            type="text"
            name="stackoverflow"
            // label="First Name"
            placeholder="stackoverflow"
            register={register}
            errors={formState.errors}
            // onBlur={handleSubmit(onSubmitForm)}
            // className="mb-2"
          />
        </div>
        <FromHead>Summary about the candidate</FromHead>
        {/* <div className="form-group">
        <label className="lablel">Describe here </label>
        <FormAreaInput<PersonalDetailsFormFields>
          id='summary'
          name='summary'
          placeholder="Describe here"
          register={register}
          value={defaultValues.summary ? defaultValues.summary : ''}
          errors={errors}
          onchange={(e:any) => handleChange(e,'summary')}
          // onBlur={handleSubmit(onSubmitForm)}
          />
        </div> */}
        <Editor
          editorState={editorState}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editorClassName"
          onEditorStateChange={onEditorStateChange}
        />
        <div className={Styles.alignRight}>
          <Button disabled={disable} onClick={handleSubmit(onSubmitForm)} variant="primary">
            Save
          </Button>
        </div>
      </section>
    </form>
  );
};
export default PersonalDetails;
